import { ethers } from 'ethers'
import { Logger } from '@ethersproject/logger'

export const safeWait = (
  transactionResponse: ethers.providers.TransactionResponse,
) =>
  transactionResponse.wait().catch(e => {
    if (
      // check that transaction was replaced (e.g. Speed Up)
      e.code === Logger.errors.TRANSACTION_REPLACED &&
      e.cancelled === false
    ) {
      return
    }
    // otherwise pass error
    ethers.logger.throwError(e.reason, e.code)
  })
